import { render, staticRenderFns } from "./beMediated.vue?vue&type=template&id=28fd3525&scoped=true&"
import script from "./beMediated.vue?vue&type=script&lang=js&"
export * from "./beMediated.vue?vue&type=script&lang=js&"
import style0 from "./beMediated.vue?vue&type=style&index=0&id=28fd3525&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fd3525",
  null
  
)

export default component.exports